export default __webpack_public_path__ + "static/media/blankImg.5a3a986f.png";